import { createContext } from 'react';

export const SwiperContext = createContext();